export class HtmlBuilder {

  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<div class="wf-relative wf-pt-1">
        ${this.getTopTitle()}
        ${this.getProgressBar()}
    </div>`;
  }

  getTopTitle() {
    if (this.content.hasTitle) {
      return `<div class="wf-flex wf-items-center wf-justify-between wf-mb-1 ">
        <div
          id="${this.ids.textId}"
          class="wf-text-xs wf-font-semibold wf-inline-block wf-py-1 wf-px-2 ${this.classes.classes}"
        >${this.content.text}</div>
        <div class="text-right ${this.classes.textClasses}">${this.content.progressWidth}%</div>
      </div>`
    }
    return  ``
  }

  getProgressBar() {
    return `<div
      id="${this.ids.containerId}"
      class="wf-overflow-hidden wf-h-4 wf-mb-4 wf-text-xs wf-flex ${this.classes.containerClasses}"
    >
      <div
        id="${this.ids.id}"
        class="wf-shadow-none wf-flex wf-items-center wf-flex-row wf-text-white wf-px-2 wf-whitespace-nowrap wf-justify-between ${this.classes.classes}"
      >${this.getTextTitle()}</div>
    </div>`
  }

  getTextTitle() {
    if (!this.content.hasTitle) {
      return `<div
        class="wf-uppercase"
        >${this.content.text}</div>
        <div>${this.content.progressWidth}%</div>`
    }
    return ``;
  }
}
